import { BLOG_CONSTANTS } from './config'

type BlogAnalyticsEvent =
  | 'article_view'
  | 'scroll_depth'
  | 'share_click'
  | 'tag_click'
  | 'show_more_click'

export async function trackEvent(
  eventName: BlogAnalyticsEvent,
  data: Record<string, unknown>
): Promise<void> {
  try {
    if (data.slug && !BLOG_CONSTANTS.SLUG_REGEX.test(data.slug as string)) {
      console.error(`Invalid slug format: ${data.slug}`)
      return
    }

    // TODO: create /api/analytics route or replace with project analytics provider
    await fetch('/api/analytics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event: eventName,
        timestamp: new Date().toISOString(),
        ...data,
      }),
    })
  } catch {
    // Silently fail analytics
  }
}

export function trackArticleView(slug: string, title: string): void {
  trackEvent('article_view', { slug, title })
}
